import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import {connect} from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {TreeView, TreeItem} from '@mui/x-tree-view';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import getMenuItems from '../MenuItem/MenuItems.js';
import {commonOperations} from '../../../reducks/common/index.js';
import {authOperations} from '../../../reducks/auth/index.js';
import CommonTheme from '../../../Theme.js';
import withRouter from '../../organisms/withRouter.js';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  tree: {
    height: 'auto',
    flexGrow: 1,
    maxWidth: 260,
    marginLeft: 10,
  },
  minorItem: {
    'fontSize': 'small',
    '&:hover': {
      backgroundColor: CommonTheme.palette.primary.main,
    },
  },
  minorItemDisable: {
    'fontSize': 'small',
    'color': 'gray',
    'cursor': 'default',
    '&:hover': {
      backgroundColor: CommonTheme.palette.primary.dark,
    },
  },
  minorGroup: {
    marginLeft: '8px',
  },
});

class SideMenu extends React.Component {
  /**
   * コンストラクタ。
   * @param {object} props プロパティ
   */
  constructor(props) {
    super(props);

    this.state = {
      roleMenuItems: [],
    };
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    const {getRoleMenuItems} = this.props;
    // 権限マスタからメニュー項目を取得
    const roleMenuItems = await getRoleMenuItems();

    this.setState({
      roleMenuItems: roleMenuItems,
    });
  };

  /**
   * 大項目単位の要素生成。
   *
   * @param {MajorItem[]} menuItems 大項目単位のメニュー項目
   * @return {JSX.Element} 大項目単位の要素
   */
  renderMajorItem = (menuItems) => {
    const {classes} = this.props;

    const element = [];

    for (let i = 0; i < menuItems.length; i++) {
      const majorItem = menuItems[i];

      // 遷移先が登録されている場合はクリック時の処理を登録
      let click = null;
      if (majorItem.hasOwnProperty('path') || majorItem.hasOwnProperty('action')) {
        click=()=>{
          this.clickMenuItem(majorItem);
        };
      }

      element.push(
          <TreeItem
            key={i.toString()}
            nodeId={i.toString()}
            label={majorItem.name}
            onClick={click}
            classes={{
              group: classes.minorGroup,
            }}
          >
            {this.renderMinorItem(majorItem.items, i)}
          </TreeItem>,
      );
    }

    return element;
  };

  /**
   * 小項目単位の要素生成。
   * サイドメニューでは中項目は描画しない。
   *
   * @param {MinorItem[]} minorItems 小項目単位のメニュー項目
   * @param {number} mjIdx 大項目のインデックス
   * @return {JSX.Element} 小項目単位の要素
   */
  renderMinorItem = (minorItems, mjIdx) => {
    const {classes} = this.props;

    const element = [];

    for (let i = 0; i < minorItems.length; i++) {
      const minorItem = minorItems[i];
      const key = [mjIdx, i].join('_');

      const cls = minorItem.path ? classes.minorItem : classes.minorItemDisable;

      element.push(
          <TreeItem
            key={key}
            nodeId={key}
            label={minorItem.name}
            classes={{
              label: cls,
            }}
            onClick={() => {
              this.clickMenuItem(minorItem);
            }}
          />,
      );
    }

    return element;
  };

  /**
   * サイドメニュー項目クリック時の処理。
   *
   * @param {string} item 遷移先パス
   */
  clickMenuItem = (item) => {
    const {dirty, doShowMessage, isEditPage, navigate} = this.props;

    // クリック時アクションが指定されていれば実行
    if (item.hasOwnProperty('action')) {
      item.action(this.props);
      return;
    }

    // パスが指定されていれば実行
    if (item.hasOwnProperty('path')) {
      const path = item.path;

      // 編集されている場合は遷移確認メッセージ
      if (isEditPage && dirty) {
        doShowMessage({
          message: 'TKSCS00038W',
          action: () => {
            // OKを押すと画面遷移
            navigate(path, {});
          },
        });
      } else {
        // 編集されていない場合は確認なしで遷移
        navigate(path, {});
      }
    }
  };

  render = () => {
    const {classes, userInfo, expandedMenuItems} = this.props;
    const menuItems = getMenuItems(userInfo, this.state.roleMenuItems);

    return (
      <TreeView
        className={classes.tree}
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={expandedMenuItems}
        defaultExpandIcon={<ChevronRightIcon />}
        onNodeToggle={this.handleToggle}
      >
        {this.renderMajorItem(menuItems)}
      </TreeView>
    );
  };

  handleToggle = (event, nodeIds) => {
    // ストアに開いているメニュー項目のnodeIdを保持
    this.props.setExpandedMenuItems(nodeIds);
  };
};

const mapStateToProps = (state) => ({
  userInfo: state.auth.userInfo,
  expandedMenuItems: state.auth.expandedMenuItems,
});

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  getRoleMenuItems: authOperations.doGetMenuItemsOperation,
  setExpandedMenuItems: authOperations.doSetExpandedMenuItems,
};

SideMenu.propTypes = {
  classes: PropTypes.object,
  doShowMessage: PropTypes.func,
  dirty: PropTypes.bool,
  isEditPage: PropTypes.bool,
  userInfo: PropTypes.object,
  navigate: PropTypes.func,
  expandedMenuItems: PropTypes.arrayOf(PropTypes.string),
  getRoleMenuItems: PropTypes.func.isRequired,
  setExpandedMenuItems: PropTypes.func.isRequired,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(SideMenu)),
);
